import { CITY_POINTS } from "@/components/world/worldMapData";

export const arcPath = ([x1, y1], [x2, y2], lift = 0.34) => {
  const dx = x2 - x1;
  const dy = y2 - y1;
  const dist = Math.sqrt(dx * dx + dy * dy);
  const cx = (x1 + x2) / 2;
  const cy = (y1 + y2) / 2 - dist * lift;
  return `M${x1} ${y1} Q${cx} ${cy} ${x2} ${y2}`;
};

export const arcFor = (a, b, lift) =>
  arcPath(CITY_POINTS[a], CITY_POINTS[b], lift);
